import { createContext, useContext } from "react";

export const ConsumerLayoutContext = createContext(false);

export function useIsInsideConsumerLayout() {
  return useContext(ConsumerLayoutContext);
}
